/**
 * Tuotesivun lisäpalvelut: kaiverrus + lahjapaketointi (Symmetry-teema)
 *
 * Kovakoodatut variant ID:t:
 *   Kaiverruspalvelu:   57340563521913
 *   Lahjapaketointi:    57340762423673
 *
 * Sama JS-tiedosto käsittelee molemmat. Snipetit lataavat tämän tiedoston,
 * guard estää duplikaattikäynnistyksen jos kumpikin snippet renderöityy.
 */
(function () {
  if (window.__productExtrasGrowlyInit) return;
  window.__productExtrasGrowlyInit = true;

  var ENGRAVING_VARIANT_ID = 57340563521913;
  var GIFT_WRAP_VARIANT_ID = 57340762423673;

  function init() {
    var form = document.querySelector('form.js-product-form');
    if (!form) return;

    var engravingCheckbox = document.getElementById('engraving-checkbox');
    var engravingTextWrapper = document.querySelector('.product-engraving-growly__text-wrapper');
    var engravingTextInput = document.getElementById('engraving-text');
    var giftWrapCheckbox = document.getElementById('gift-wrap-checkbox');

    if (!engravingCheckbox && !giftWrapCheckbox) return;

    if (engravingCheckbox && engravingTextWrapper && engravingTextInput) {
      engravingCheckbox.addEventListener('change', function () {
        if (engravingCheckbox.checked) {
          engravingTextWrapper.hidden = false;
        } else {
          engravingTextWrapper.hidden = true;
          engravingTextInput.value = '';
        }
      });
    }

    form.addEventListener('submit', function (e) {
      handleSubmit(e, form, {
        engravingCheckbox: engravingCheckbox,
        engravingTextInput: engravingTextInput,
        giftWrapCheckbox: giftWrapCheckbox
      });
    }, true);
  }

  function handleSubmit(e, form, els) {
    var wantsEngraving = els.engravingCheckbox && els.engravingCheckbox.checked;
    var wantsGiftWrap = els.giftWrapCheckbox && els.giftWrapCheckbox.checked;

    if (!wantsEngraving && !wantsGiftWrap) {
      return;
    }

    var engravingText = '';
    if (wantsEngraving) {
      engravingText = (els.engravingTextInput && els.engravingTextInput.value || '').trim();
      if (!engravingText) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(form, 'Syota kaiverrusteksti');
        return;
      }
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);
    var mainProductId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);

    var productTitleEl = document.querySelector('.product-title')
      || document.querySelector('[itemprop="name"]')
      || document.querySelector('h1');
    var productTitle = productTitleEl ? productTitleEl.textContent.trim() : 'Tuote';

    var mainProductData = {
      id: mainProductId,
      quantity: quantity
    };

    var properties = {};
    for (var pair of formData.entries()) {
      var key = pair[0];
      var value = pair[1];
      if (key.indexOf('properties[') === 0) {
        var match = key.match(/properties\[(.*?)\]/);
        if (match && value && String(value).trim() !== '') {
          properties[match[1]] = value;
        }
      }
    }
    if (Object.keys(properties).length > 0) {
      mainProductData.properties = properties;
    }

    var items = [mainProductData];

    if (wantsEngraving) {
      items.push({
        id: ENGRAVING_VARIANT_ID,
        quantity: quantity,
        properties: {
          'Kaiverrusteksti': engravingText,
          'Kaiverrus tuotteelle': productTitle,
          '_Tuote': mainProductId,
          '_Linkitetty': 'kyllä'
        }
      });
    }

    if (wantsGiftWrap) {
      items.push({
        id: GIFT_WRAP_VARIANT_ID,
        quantity: quantity,
        properties: {
          'Lahjapaketointi tuotteelle': productTitle,
          '_Tuote': mainProductId,
          '_Linkitetty': 'kyllä'
        }
      });
    }

    addToCart(items, form);
  }

  function getSectionsToUpdate() {
    var ids = [];
    var els = [];
    var pageHeader = document.querySelector('page-header');
    var cartDrawer = document.querySelector('cart-drawer');
    if (pageHeader && pageHeader.dataset.sectionId) {
      ids.push(pageHeader.dataset.sectionId);
      els.push(pageHeader);
    }
    if (cartDrawer && cartDrawer.dataset.sectionId) {
      ids.push(cartDrawer.dataset.sectionId);
      els.push(cartDrawer);
    }
    return { ids: ids, els: els };
  }

  async function addToCart(items, form) {
    var submitBtn = form.querySelector('[name="add"]');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('is-loading');
    }

    var sectionInfo = getSectionsToUpdate();

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: sectionInfo.ids.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        var errorData = await response.json().catch(function () { return {}; });
        var msg = errorData.description || errorData.message || 'Virhe tuotteen lisaamisessa';
        showError(form, msg);
        return;
      }

      var data = await response.json();

      if (data.sections) {
        sectionInfo.els.forEach(function (el) {
          var html = data.sections[el.dataset.sectionId];
          if (html && typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(html);
          }
        });
      }

      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));

      var afterAddToCart = window.theme && window.theme.settings && window.theme.settings.afterAddToCart;
      var drawer = document.querySelector('.js-cart-drawer');
      if (afterAddToCart === 'notification') {
        var template = document.getElementById('AddedNotification');
        if (template) {
          var notification = template.content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data && data.items && data.items[0] ? data.items[0].product_title : '';
          var notificationContainer = document.querySelector('.pageheader--sticky') || document.body;
          notificationContainer.appendChild(notification);
        }
      } else if (afterAddToCart === 'page') {
        window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
        return;
      } else {
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }
      }
    } catch (err) {
      showError(form, 'Virhe tuotteen lisaamisessa ostoskoriin');
    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('is-loading');
      }
    }
  }

  function showError(form, message) {
    var errorEl = form.querySelector('.js-form-error');
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.innerHTML = '';
      errorEl.appendChild(document.createTextNode(message));
      setTimeout(function () {
        errorEl.hidden = true;
        errorEl.innerHTML = '';
      }, 3000);
    } else {
      window.alert(message);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();